import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import CustomerDashboard from "@/pages/CustomerDashboard";
import CustomerLogin from "@/pages/CustomerLogin";
import Forbidden from "@/pages/Forbidden";
import NakshaStore from "@/pages/NakshaStore";
import FreeSample from "@/pages/FreeSample";
import DesignStudio from "@/pages/DesignStudio";
import AboutUs from "@/pages/AboutUs";
import { Privacy, Refund, Terms, Contact } from "@/pages/Legal";
import Professionals from "@/pages/Professionals";
import ProfessionalProfile from "@/pages/ProfessionalProfile";
import ProfessionalRegister from "@/pages/ProfessionalRegister";
import ProfessionalLogin from "@/pages/ProfessionalLogin";
import ProfessionalDashboard from "@/pages/ProfessionalDashboard";
import MitrasHub from "@/pages/MitrasHub";
import PromoBanner from "@/components/PromoBanner";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/auth/ProtectedRoute";
import { FINANCE_MITRA_ENABLED } from "@/lib/featureFlags";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AnalyticsTracker />
          <PromoBanner />
          <WhatsAppFAB />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/store" element={<NakshaStore />} />
            <Route path="/free-sample" element={<FreeSample />} />
            <Route path="/design-studio" element={<DesignStudio />} />

            {/* Legal */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />

            {/* Hire Professionals — public listing + per-pro profile */}
            <Route path="/professionals" element={<Professionals />} />
            <Route path="/professionals/:id" element={<ProfessionalProfile />} />
            <Route path="/professional/register" element={<ProfessionalRegister />} />
            <Route path="/professional/login" element={<ProfessionalLogin />} />
            <Route path="/professional/dashboard" element={<ProfessionalDashboard />} />

            {/* Mitra ecosystem — customer-facing rebrand of the
                professionals network. Five buckets (design / construction /
                property / material / finance) each render the same
                listing component scoped to their `mitra_category`. */}
            <Route path="/mitras" element={<MitrasHub />} />
            <Route path="/mitras/:bucket" element={<Professionals />} />
            <Route path="/mitras/:bucket/:id" element={<ProfessionalProfile />} />

            {/* Razorpay compliance kill-switch — until the finance vertical
                is officially activated, every finance / EMI / loan deep
                link bounces back to the homepage. Re-enable by setting
                REACT_APP_FINANCE_MITRA_ENABLED=true. */}
            {!FINANCE_MITRA_ENABLED && (
              <>
                <Route path="/finance" element={<Navigate to="/" replace />} />
                <Route
                  path="/finance-mitra"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/emi-calculator"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/loan"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/loan-assistance"
                  element={<Navigate to="/" replace />}
                />
              </>
            )}

            {/* Auth screens (public) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/customer/login" element={<CustomerLogin />} />
            <Route path="/login" element={<CustomerLogin />} />

            {/* 403 */}
            <Route path="/403" element={<Forbidden />} />

            {/* Customer */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute role="customer">
                  <CustomerDashboard />
                </ProtectedRoute>
              }
            />

            {/* Admin (both /admin and /dashboard/admin map to the admin app) */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
